import type { RouteLocationNormalized, Router } from 'vue-router'

export default defineNuxtPlugin((nuxtApp) => {
  const router = nuxtApp.$router as Router | undefined
  if (!router) return

  const retryKey = 'router_chunk_retry_state'
  const reloadKey = 'router_reload_attempt'
  let latestTarget = ''

  router.beforeEach((to: RouteLocationNormalized) => {
    latestTarget = to.fullPath
  })

  router.onError(async (error: unknown) => {
    console.error('Router error detected:', error)
    const message = error instanceof Error ? error.message : String(error || '')
    const isChunkError =
      message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Importing a module script failed')

    if (!isChunkError) return

    const now = globalThis.Date.now()
    try {
      const raw = sessionStorage.getItem(retryKey)
      const state = raw ? (JSON.parse(raw) as { count?: number; ts?: number }) : {}
      const withinWindow = typeof state.ts === 'number' && now - state.ts < 10000
      const count = withinWindow ? state.count || 0 : 0

      if (count < 1) {
        sessionStorage.setItem(retryKey, JSON.stringify({ count: count + 1, ts: now }))
        const target = latestTarget || router.currentRoute.value.fullPath
        await router.replace(target)
        return
      }

      const lastReload = sessionStorage.getItem(reloadKey)
      if (!lastReload || now - parseInt(lastReload) > 15000) {
        sessionStorage.setItem(reloadKey, now.toString())
        globalThis.window.location.reload()
      } else {
        console.error('Reload loop detected. Abort hard reload.')
      }
    } catch (e) {
      console.error('Chunk retry flow failed:', e)
    }
  })
})
